import styled, { css } from "styled-components";
import { Wrapper } from 'AppReact';

const template = styled.div`
  ${({ displayState }) => css`
    display: flex;
    align-items: center;
    justify-content: ${displayState?.borderless ? 'center' : 'space-between'}; 
    padding-left: 8px;
    padding-right: 8px;
  `}
`;

export default Wrapper(template);
